import { LegalDoc } from "@/components/site/LegalDoc";

export default function TermsPage() {
  return (
    <LegalDoc
      eyebrow="Terms & Conditions"
      title="Terms of use."
      updated="July 2026"
      intro="By using Time2Cash, you agree to these terms. Please read them carefully."
      sections={[
  {
    h: "Acceptance of these Terms",
    p: [
      "By downloading, installing, accessing or using Time2Cash, you agree to be bound by these Terms & Conditions, our Privacy Policy and any additional guidelines or policies published by us from time to time.",
      "If you do not agree with these Terms, please discontinue using the platform immediately."
    ]
  },

  {
    h: "About Time2Cash",
    p: [
      "Time2Cash is a hyperlocal digital platform operated by DIGISWING Innovation Private Limited. Our platform enables users to discover nearby opportunities, businesses, local services, community activities and various other location-based features through a single application.",
      "Time2Cash acts solely as a technology platform facilitating connections between users and does not directly provide, own or control services, businesses, products or transactions listed by users unless specifically mentioned."
    ]
  },

  {
    h: "Eligibility",
    p: [
      "You must be legally capable of entering into a binding agreement under applicable law to use Time2Cash.",
      "By using our platform, you confirm that all information provided during registration is accurate and up to date."
    ]
  },

  {
    h: "User Accounts",
    p: [
      "You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur through your account.",
      "You agree to notify us immediately if you suspect any unauthorized access to your account."
    ]
  },

  {
    h: "Acceptable Use",
    p: [
      "You agree to use Time2Cash responsibly and in compliance with all applicable laws."
    ],
    list: [
      "Do not provide false information.",
      "Do not impersonate another person or business.",
      "Do not upload illegal, offensive or misleading content.",
      "Do not abuse community features.",
      "Do not interfere with platform security.",
      "Do not misuse emergency-related features.",
      "Do not attempt to access accounts belonging to others."
    ]
  },

  {
    h: "User Content",
    p: [
      "You remain the owner of content submitted by you including images, descriptions, listings and other information.",
      "By publishing content on Time2Cash, you grant us a non-exclusive licence to display, host and distribute such content solely for operating the platform."
    ]
  },

  {
    h: "Platform Availability",
    p: [
      "We continuously improve Time2Cash and may modify, suspend or discontinue any feature without prior notice.",
      "Although we strive for uninterrupted availability, we cannot guarantee that the platform will always remain error-free or continuously available."
    ]
  },

  {
    h: "Payments, Credits & Subscriptions",
    p: [
      "Certain features may require wallet credits, subscriptions or paid plans.",
      "Applicable pricing, validity and usage conditions will be displayed before purchase."
    ]
  },

  {
    h: "Third-Party Services",
    p: [
      "Time2Cash may integrate with third-party services including payment providers, mapping services, authentication services and communication platforms.",
      "Your use of such services may also be governed by their respective terms and privacy policies."
    ]
  },

  {
    h: "Intellectual Property",
    p: [
      "All trademarks, logos, software, graphics, designs, content and technology associated with Time2Cash remain the exclusive property of DIGISWING Innovation Private Limited unless otherwise stated.",
      "You may not copy, reproduce, distribute, reverse engineer or commercially exploit any part of our platform without prior written permission."
    ]
  },

  {
    h: "Disclaimer",
    p: [
      "Time2Cash is provided on an 'as available' and 'as is' basis.",
      "We do not guarantee the accuracy, quality, legality, safety or reliability of user-generated content, businesses, listings, opportunities or communications available through the platform."
    ]
  },

  {
    h: "Limitation of Liability",
    p: [
      "To the maximum extent permitted by applicable law, DIGISWING Innovation Private Limited shall not be liable for any indirect, incidental, consequential, special or punitive damages arising out of your use of Time2Cash.",
      "Users are solely responsible for exercising their own judgment while interacting with other users."
    ]
  },

  {
    h: "Account Suspension & Termination",
    p: [
      "We reserve the right to suspend, restrict or permanently terminate accounts that violate these Terms, applicable laws or community guidelines without prior notice."
    ]
  },

  {
    h: "Changes to these Terms",
    p: [
      "These Terms may be updated from time to time.",
      "Continued use of Time2Cash after revisions become effective constitutes acceptance of the updated Terms."
    ]
  },

  {
    h: "Governing Law",
    p: [
      "These Terms shall be governed by the laws of India.",
      "Any disputes arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the competent courts having jurisdiction over the registered office of DIGISWING Innovation Private Limited."
    ]
  },

  {
    h: "Contact Us",
    p: [
      "Time2Cash",
      "A Product of DIGISWING Innovation Private Limited",
      "Website: www.time2cash.co",
      "Email: hello@time2cash.co",
      "Support: hello@time2cash.co"
    ]
  }
]}
    />
  );
}
